import { useEffect, useState } from 'react';
import core from '@gin-betting/core';
import { Subject } from 'rxjs/Subject';

import { getMinBet } from 'utils';

interface Output {
    minStake: number;
}

const {
    poller: { getPollerManager },
} = core;

let counter = 0;
let isFetched = false;

const subject$ = new Subject<number>();

function usePollingMinStake(): Output {
    const [minStake, setMinStake] = useState<number>(0);

    useEffect(() => {
        counter += 1;

        const { prevMinBet, request } = getMinBet();

        if (!prevMinBet && !isFetched) {
            isFetched = true;

            request()
                .then(minBet => {
                    subject$.next(minBet);
                })
                .catch(err => console.error(err));
        }

        setMinStake(prevMinBet);

        const subscription = subject$.subscribe(minBet => {
            setMinStake(minBet);
        });

        return () => {
            counter -= 1;
            subscription.unsubscribe();
        };
    }, []);

    return { minStake };
}

const pollInterval$ = getPollerManager().getIntervalObserve();
pollInterval$.subscribe(() => {
    if (!counter) return;

    const { request } = getMinBet();

    request()
        .then(minBet => {
            subject$.next(minBet);
        })
        .catch(err => console.error(err));
});

export default usePollingMinStake;
